import React from "react";
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  accountSelector,
  pupSelector,
} from "../../../services/selector/index.";
import "../../../assets/style/table/newspost.scss";
import {
  IconEdit,
  IconLockAccount,
  IconNext,
  IconPre,
  IconSpin,
  IconUnLockAccount,
  IconXmark,
} from "../../../assets/icon";
import { useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { renameStatusAcc, renameTypeAcc } from "../../../utils/convertNumber";
import {
  changeStatusUser,
  deleteAccount,
  getAllAccount,
  setOpenPUEditAcc,
  setPageUser,
} from "../../../services/slice/AccountSlice";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalDelete from "../Modal/delete/ModalDelete";

const TableAccount = () => {
  const statePup = useSelector(pupSelector);
  const { t } = useTranslation();
  const accState = useSelector(accountSelector);
  const { data, total, callBackRequest, isLoading, config } = accState;
  const { option } = config;
  const { dataDelete } = statePup;
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState();
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  useEffect(() => {
    if (callBackRequest) {
      dispatch(getAllAccount());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callBackRequest]);
  useEffect(() => {
    dispatch(getAllAccount(accState.config));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accState.config]);
  // useEffect(() => {
  //   return dispatch(resetConfig());
  // }, [dispatch]);
  const dataSource = useMemo(() => {
    const result = data.map((item, index) => {
      return {
        ...item,
        key: item.id,
        active: t(renameStatusAcc(item.active)),
        type: renameTypeAcc(parseInt(item.type)),
        STT:
          total > 10 && option.offset >= 2
            ? (option.offset - 1) * 10 + index + 1
            : index + 1,
      };
    });
    return result;
  }, [data, page, t, total]);
  const handleShowModalChangeStatusUser = (value) => {
    setStatus(value.active);
    dispatch(
      setOpenPUDelete({
        stateOpen: true,
        content: value.record.username,
        id: value.record.id,
      })
    );
  };

  const handleChangeStatus = () => {
    const data = {
      userId: dataDelete.id,
      active: status,
    };
    dispatch(changeStatusUser(data));
    dispatch(setOpenPUDelete({ stateOpen: false, content: "", id: "" }));
  };
  const handleShowEditModal = (value) => {
    dispatch(setOpenPUEditAcc({ stateOpen: true, contentEdit: value }));
  };
  const handleDelete = () => {
    setIsDelete(false);
    dispatch(
      deleteAccount({ id: dataDelete.id, name: dataDelete.contentPUDelete })
    );
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Tên tài khoản" />,
      dataIndex: "username",
      key: "username",
      className: "title centerCell",
    },
    {
      title: <TranslateText text="Quyền" />,
      dataIndex: "type",
      key: "type",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Trạng thái" />,
      dataIndex: "active",
      key: "active",
      className: "centerCell",
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace",
      render: (text, record) => {
        return (
          <div className="evenSpace" style={{ minWidth: "120px" }}>
            {record.active === t("Đang kích hoạt") ? (
              <span
                className="pointer iconTbl"
                onClick={() =>
                  handleShowModalChangeStatusUser({ record, active: 0 })
                }
              >
                <Tooltip title="Vô hiệu hóa">
                  <IconLockAccount />
                </Tooltip>
              </span>
            ) : (
              <span
                className="pointer iconTbl"
                onClick={() =>
                  handleShowModalChangeStatusUser({ record, active: 1 })
                }
              >
                <Tooltip title="Khôi phục">
                  <IconUnLockAccount />
                </Tooltip>
              </span>
            )}
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => {
                setIsDelete(true);
                dispatch(
                  setOpenPUDelete({
                    stateOpen: true,
                    content: record.username,
                    id: record.id,
                  })
                );
              }}
            >
              {" "}
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const tableLoading = {
    spinning: isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      {dataDelete.isOpenPUDelete && isDelete ? (
        <ModalDelete
          setIsDelete={setIsDelete}
          handleDelete={handleDelete}
          width={600}
          textDisable="Bạn có đồng ý xóa tài khoản"
          title="Xóa tài khoản"
          // content="Bạn có đồng ý xóa bài viết này không?"
        />
      ) : null}
      {status === 0 && !isDelete ? (
        <ModalDelete
          width={600}
          textDisable="Bạn có đồng ý vô hiệu hóa tài khoản"
          handleDelete={handleChangeStatus}
          title="Vô hiệu hóa tài khoản"
        />
      ) : null}
      {status === 1 && !isDelete ? (
        <ModalDelete
          width={600}
          textDisable="Bạn có đồng ý khôi phục tài khoản"
          handleDelete={handleChangeStatus}
          title="Khôi phục tài khoản"
        />
      ) : null}

      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="wrapperTblNewsPost tableContent"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageUser(value));
                  },
                  total,
                  pageSize: 10,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableAccount;
